import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { CentroCustoCadastro } from '../models/centro-custo-cadastro';
import { Observable } from 'rxjs';
import { CentroCusto } from '../models/centro-custo';
import { ResponseBase } from '../models/response-base';

@Injectable({
  providedIn: 'root'
})
export class CentroCustoService {

  API: string = environment.API + 'Portal/centroscustos';

  constructor(private http: HttpClient) { }

  add(centroCusto: CentroCustoCadastro, cedenteGuid: string, gestorGuid: string): Observable<ResponseBase<CentroCusto>> {
    return this.http.post<ResponseBase<CentroCusto>>(`${this.API}/cedentes/${cedenteGuid}/gestores/${gestorGuid}`, centroCusto);
  }

  getAll(cedenteGuid: string): Observable<ResponseBase<CentroCusto[]>> {
    return this.http.get<ResponseBase<CentroCusto[]>>(`${this.API}/cedentes/${cedenteGuid}`);
  }

  delete(centroCustoId: number, cedenteGuid: string, gestorGuid: string): Observable<ResponseBase<CentroCusto>> {
    return this.http.delete<ResponseBase<CentroCusto>>(`${this.API}/${centroCustoId}/cedentes/${cedenteGuid}/gestores/${gestorGuid}`);
  }

  update(centroCustoId: number, centroCusto: CentroCustoCadastro, cedenteGuid: string, gestorGuid: string):
  Observable<ResponseBase<CentroCusto>> {
    return this.http.put<ResponseBase<CentroCusto>>
    (`${this.API}/${centroCustoId}/cedentes/${cedenteGuid}/gestores/${gestorGuid}`, centroCusto);
  }

  getById(centroCustoId: number, cedenteGuid: string): Observable<ResponseBase<CentroCusto>> {
    return this.http.get<ResponseBase<CentroCusto>>(`${this.API}/${centroCustoId}/cedentes/${cedenteGuid}`);
  }
}
